import { CashRegisterModelType } from '@teinor/erp/types/company/cashRegister'
import { CashRegisterMoneyModelAdd } from '@teinor/erp/types/company/cashRegister/cashRegisterMoney'
import { relatedTypesInversed } from '@teinor/erp/types/company/config/paymentType'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { MediumModalCreateEdit } from '../../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { ModalEditComponentProps } from '../../../../../../../baseComponents/ModalsLayouts/types'
import { RowData } from '../../../../../../../baseComponents/TwinTable/types'
import { FormElement, FormRender } from '../../../../../../../forms/FormRenderer/types'
import TextArea from '../../../../../../../forms/Input/TextArea'
import { BeforeSubmitHandler, OnSubmit } from '../../../../../../../forms/TwinForm/types'
import PaymentTypesAndSellsRegisterTPV from '../../../../../../../specificComponents/inputTableLayouts/order/OrderSellTicketTPVLayout/components/PaymentTypesRegisterTPV'
import { PaymentTypeModelTypeExtendedTPV } from '../../../../../../../specificComponents/inputTableLayouts/order/OrderSellTicketTPVLayout/types'
import twinFetchPost, { twinFetchPostJSON, twinFetchPostPrinter } from '../../../../../../../utils/globals/data'
import { displayDateWithFormattedHours } from '../../../../../../../utils/globals/date'
import { dictionaryComplexFromJsonArr, TwinDictionary } from '../../../../../../../utils/globals/dictionary'
import { returnClassOfSpanTemplate } from '../../../../../../../utils/globals/tailwind'
import withLoading from '../../../../../../../utils/hoc/withLoading'
import useEditDeleteModal from '../../../../../../../utils/hooks/useEditDeleteModal'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import { AllReduxPayloads } from '../../../../../../../utils/reducers'
import { getUserInfo } from '../../../../../../../utils/reducers/getters'
import { PaymentTypesPayload } from '../../../../../../../utils/reducers/payments/paymentTypes'
import { PaymentTypesRegisterMoneyTPV } from '../../types'
import CashRegisterMoneyTable from '../CashRegisterMoneyTable'
import ModalSavedSellTickets from '../ModalSavedSellTickets'
import { roundNumberAndDecimals } from '@teinor/erp/prices'
import { totalCalculateParams } from '@teinor/erp/prices/quote/calculate'
import '../modalCashRegister.sass'
import Checkbox from '../../../../../../../forms/Checkbox'

type ModalCloseCashRegisterProps = ModalEditComponentProps & ModalCloseCashRegisterLogicProps & {
    MyWorkingCenter: TwinDictionary
    MyWorkingCenterStationId?: number
}

interface CashRegisterModelTypeExtended extends CashRegisterModelType {
    companyName: string
    workingCenterName: string
    workingCenterStationName: string
}

const ModalCloseCashRegister: React.FC<ModalCloseCashRegisterProps> = ({ onSubmit, MyWorkingCenter, MyWorkingCenterStationId, ...rest }) => {
    const { t } = useTwinTranslation()
    const { paymentTypesRegisterMoney, handleBeforeSubmit, openModal, setOpenModal, handleOnSubmit, setPaymentTypesRegisterMoney, handleSavedTickets } = useModalCloseCashRegisterLogic({ allRowData: rest.allRowData, onSubmit, ...rest })
    const user = getUserInfo()
    const workingCenterStationsMemorized = useMemo(() => (MyWorkingCenter?.WorkingCenterStations?.length) ? dictionaryComplexFromJsonArr(MyWorkingCenter?.WorkingCenterStations || []) : null, [MyWorkingCenter])
    let extraFields: FormElement<keyof CashRegisterModelTypeExtended>[] = []
    if (MyWorkingCenterStationId) {
        extraFields.push({
            name: 'workingCenterStationName',
            label: t('workStation', 'Puesto'),
            component: 'TextField',
            value: workingCenterStationsMemorized?.[MyWorkingCenterStationId]?.name,
        })
    }
    const fields: FormRender<CashRegisterModelTypeExtended> = [
        {
            cols: 4,
            title: t('store', 'Tienda'),
            elements: [
                {
                    name: 'workingCenterName',
                    label: t('name','Nombre'),
                    component: 'TextField',
                    value: MyWorkingCenter?.name,
                },
                ...extraFields,
                {
                    name: 'CloseEmployeeId',
                    label: t('employee','Empleado'),
                    component: 'TextField',
                    value: user?.Employee?.fullname_short,
                },
                {
                    name: 'WorkingCenterId',
                    component: 'InputHidden',
                    value: MyWorkingCenter.id,
                },
                {
                    name: 'WorkingCenterStationId',
                    component: 'InputHidden',
                    value: MyWorkingCenterStationId || undefined
                },
            ]
        },
        {
            cols: 5,
            title: t('opening', 'Apertura'),
            elements: [
                {
                    name: 'full_assigned_number',
                    label: t('number','Número'),
                    component: 'TextField',
                    value: rest.allRowData?.cashRegister?.full_assigned_number || '-',
                },
                {
                    name: 'createdAt',
                    label: t('openingDate','Fecha de apertura'),
                    component: 'TextField',
                    value: displayDateWithFormattedHours(new Date(rest.allRowData?.cashRegister?.createdAt)),
                    className: returnClassOfSpanTemplate(2)
                },
                {
                    name: 'endDate',
                    label: t('closeDate','Fecha de cierre'),
                    component: 'TextField',
                    value: displayDateWithFormattedHours(new Date()),
                    className: returnClassOfSpanTemplate(2)
                },
                {
                    name: 'id',
                    component: 'InputHidden',
                    value: rest.allRowData?.cashRegister?.id
                },
            ]
        },
    ]
    return (
        <MediumModalCreateEdit fields={fields} url={'/api/app/order/tpv/cashRegister/closeCashRegister'} translations={{
        title: t('closeCashRegister', 'Cierre de caja'),
        button: t('closeCashRegisterAct', 'Cerrar caja')
        }} haveButtonPermissions={true} {...rest} triggerSuccess={false} beforeSubmit={handleBeforeSubmit} onSubmit={handleSavedTickets} className='modal_cash_register notFlexAutoFormRender' triggerErrors={false} triggerOpen={false} extraButtons={[<Checkbox name='printOnClose' label={t('printReceipt', 'Imprimir recibo')}/>]} >
            <div className='flex w-full mt-10 '>
                <TextArea label={t('notes', 'Notas')} name='notes' />
            </div>
            <CashRegisterMoneyTable isCloseCashRegister={true} {...{ cashRegisterMoneyRows: paymentTypesRegisterMoney?.cashRegisterMoneyRows || [], setPaymentTypesRegisterMoney }} />
            <div className='flex flex-auto flex-col mt-20'>
                <PaymentTypesAndSellsRegisterTPV paymentTypesTPV={paymentTypesRegisterMoney?.allPaymentMethodsTotals || []} />
            </div>
            {openModal?.type === 'delete' ? <ModalSavedSellTickets setOpenModal={setOpenModal} setOpened={() => setOpenModal(null)} onSubmit={handleOnSubmit} allRowData={openModal?.allRowData} />: null}
        </MediumModalCreateEdit>
    )
}

interface ModalCloseCashRegisterLogicProps extends ReduxPaymentTypes {
    allRowData?: RowData
    onSubmit: OnSubmit
}

const useModalCloseCashRegisterLogic = ({ allRowData, onSubmit, paymentTypes }: ModalCloseCashRegisterLogicProps) => {
    const [paymentTypesRegisterMoney, setPaymentTypesRegisterMoney] = useState<PaymentTypesRegisterMoneyTPV | null>(null)
    const { openModal, setOpenModal } = useEditDeleteModal()
    const {t} = useTwinTranslation()
    const errorMessage = t('couldNotConnectWithPrinter', 'No se ha podido conectar con la impresora')

    const handleSavedTickets: OnSubmit = useCallback(async (result, vals) => {
        if (result.status === 200) {
            onSubmit?.(result, vals)
            setOpenModal(null)
        } else {
            const responseJSON = await result.json()
            if (result.status === 367) {
                const myresult = await twinFetchPostPrinter('/print', responseJSON, errorMessage)
                if (myresult) {
                    onSubmit?.(myresult, vals)
                    setOpenModal(null)
                }
            }else if (responseJSON && responseJSON?.errors?.[0]?.msg === 'haveSavedSellTickets') {
                setOpenModal({ type: 'delete', allRowData: { ...allRowData?.cashRegister, values: vals } })
                return false
            }
        }
        return true
    }, [allRowData?.cashRegister, setOpenModal, onSubmit, errorMessage])

    const handleBeforeSubmit: BeforeSubmitHandler = useCallback((vals: any) => {
        const myCashRegisterMoneyRows = []
        for (const element of paymentTypesRegisterMoney?.cashRegisterMoneyRows || []) {
            if (element.endMoney === null) {
                element.endMoney = roundNumberAndDecimals(element.money || 0, totalCalculateParams)
            }
            const diff = parseFloat(String(element.money)) - parseFloat(String(element.endMoney))
            myCashRegisterMoneyRows.push({ ...element, 'CashRegisterId': allRowData?.cashRegister?.id, diff, payment_data: vals.notes})
        }
        vals.cashRegisterMoneyRows = myCashRegisterMoneyRows
        if (!vals.WorkingCenterStationId) {
            delete vals.WorkingCenterStationId
        }
        return true
    }, [paymentTypesRegisterMoney?.cashRegisterMoneyRows, allRowData?.cashRegister])

    const handleOnSubmit: OnSubmit = useCallback(async (res, vals) => {
        if (!res) {
            const result = await twinFetchPost('/api/app/order/tpv/cashRegister/closeCashRegister', { ...vals }) 
            if (result) {
                if (result.status === 200) {
                    onSubmit?.(result, vals)
                    setOpenModal(null)
                }
            }
        } else {
            onSubmit?.(res, vals)
        }
    }, [onSubmit, setOpenModal])

    const getAllCashRegisterMoneysByCashRegister = useCallback(async () => {
        if (allRowData?.cashRegister?.id) {
            const result = await twinFetchPostJSON('/api/app/order/tpv/cashRegister/cashRegisterMoney/getAllCashRegisterMoneyLogsByCashRegister', { where: { 'CashRegisterMoney.CashRegisterId': allRowData?.cashRegister?.id } })
            if (result) {
                const dictCashRegisterMoneys: TwinDictionary = {}
                const myCashRegisterMoneyRow: CashRegisterMoneyModelAdd[] = []
                for (const element of result) {
                    const cashRegisterMoney = JSON.parse(JSON.stringify(element?.CashRegisterMoney))
                    if (!dictCashRegisterMoneys?.[cashRegisterMoney.PaymentTypeId]) {
                        delete element.CashRegisterMoney
                        const myCashRegisterMoneyLogs = []
                        myCashRegisterMoneyLogs.push(element)
                        dictCashRegisterMoneys[cashRegisterMoney.PaymentTypeId] = { ...cashRegisterMoney, CashRegisterMoneyLogs: myCashRegisterMoneyLogs, money: element.endMoney, endMoney: element.endMoney }
                    } else {
                        dictCashRegisterMoneys[cashRegisterMoney.PaymentTypeId]['CashRegisterMoneyLogs'].push(element)
                    }
                }
                const myResult: PaymentTypeModelTypeExtendedTPV[] = []
                for (const key in paymentTypes?.activeTpv) {
                    const element = paymentTypes?.activeTpv[parseInt(key)]
                    if (element) {
                        myResult.push({ ...element, CashRegisterMoney: dictCashRegisterMoneys?.[element.id] })
                    }
                    if (element?.relatedType === relatedTypesInversed['cash']) {
                        myCashRegisterMoneyRow.push({ ...dictCashRegisterMoneys?.[element.id], PaymentType: element })
                    }
                }
                setPaymentTypesRegisterMoney({ allPaymentMethodsTotals: myResult, cashRegisterMoneyRows: myCashRegisterMoneyRow })
            }
        }

    }, [setPaymentTypesRegisterMoney, allRowData?.cashRegister?.id, paymentTypes?.activeTpv])

    useEffect(() => {
        getAllCashRegisterMoneysByCashRegister()
    }, [getAllCashRegisterMoneysByCashRegister])

    return { paymentTypesRegisterMoney, handleBeforeSubmit, openModal, setOpenModal, handleOnSubmit, setPaymentTypesRegisterMoney, handleSavedTickets }
}

const paymentTypesDispatch = {
    setPaymentTypes: (payload: PaymentTypesPayload) => ({ type: 'CHANGE_PAYMENTTYPES', payload }),
}

export type ReduxPaymentTypes = ConnectedProps<typeof PaymentTypesConnect>
const mapPaymentTypesConnector = (state: AllReduxPayloads) => ({ paymentTypes: state.paymentTypes })
const PaymentTypesConnect = connect(mapPaymentTypesConnector, paymentTypesDispatch)
const PaymentTypesConnectLoading = withLoading(ModalCloseCashRegister, [{ fetchUrl: '/api/app/config/payment/paymentType/getAllPaymentTypes', propName: 'paymentTypes', setFunctionName: 'setPaymentTypes' }])
const ModalCloseCashRegisterConnect = PaymentTypesConnect(PaymentTypesConnectLoading)

export default ModalCloseCashRegisterConnect